import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    inputRow: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(1),
    },
    alertContainer: {
        marginBottom: theme.spacing(3),
    },
    sectionsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        marginTop: theme.spacing(5),
    },
}));
